export const UNKNOWN_ERROR = 'An unknown error occurred. Please try again later.';
export const UNKNOWN_AXIOS_ERROR_CODE = 'UNKNOWN_AXIOS_ERROR';
export const UNAUTHORIZED_AXIOS_ERROR_CODE = '401';
export const FORBIDDEN_AXIOS_ERROR_CODE = '403';
export const NOT_FOUND_AXIOS_ERROR_CODE = '404';
export const CONFLICT_AXIOS_ERROR_CODE = '409';
export const FAILED_DEPENDENCY_ERROR_CODE = '424';
export const GENERIC_AXIOS_ERROR_CODE = 'ERR_BAD_REQUEST';
export const AXIOS_ERROR_NETWORK = 'ERR_NETWORK';
export const AXIOS_ERROR_CONNECTION_ABORTED = 'ECONNABORTED';
export const AXIOS_ERROR_TIMEOUT = 'ETIMEDOUT';
/** Axios codes of requests that got no response because the server could not be reached. */
export const CONNECTION_ERROR_CODES: readonly string[] = [
  AXIOS_ERROR_NETWORK,
  AXIOS_ERROR_CONNECTION_ABORTED,
  AXIOS_ERROR_TIMEOUT,
];
export const CONNECTION_ERROR_MESSAGE =
  'Connection to the MINERVA server was lost. Please check your internet connection and try again. ' +
  'If the problem persists, contact the system administrator.';

export const HTTP_ERROR_MESSAGES = {
  400: "The server couldn't understand your request. Please check your input and try again.",
  401: "You're not authorized to access this resource. Please log in or check your credentials.",
  403: "Access Forbidden! You don't have permission to access this resource.",
  404: "The page you're looking for doesn't exist. Please verify the URL and try again.",
  424: 'Failed Dependency. The request cannot be completed due to existing dependencies.',
  500: 'Unexpected server error. Please try again later or contact support.',
  501: 'Sorry, this feature is not yet implemented. Please try again later.',
  503: 'Service Unavailable! The server is currently down for maintenance. Please try again later.',
};
